
import React from "react";
import PricingPlanCard from "./PricingPlanCard";
import { formatPrice } from "./formatPrice";
import { getPlanIcon, getButtonColor, getIconColor } from "./utils/planStyling";
import { Plan } from "./hooks/usePricingPlans";

type PlansListProps = {
  plans: Plan[];
  onSelectPlan: (plan: Plan) => void;
};

const PlansList = ({ plans, onSelectPlan }: PlansListProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 py-8">
      {plans.map((plan) => {
        const planProps = {
          icon: getPlanIcon(plan.name),
          iconColor: getIconColor(plan.name),
          title: plan.name,
          description: `${formatPrice(plan.price, plan.currency)}/month`,
          isBoldPrice: true,
          features: plan.features || [],
          buttonText: plan.is_disabled ? (plan.disabled_text || 'Coming Soon') : (plan.price === 0 ? 'Start Free' : 'Select Plan'),
          buttonColor: getButtonColor(plan.name),
          isRecommended: plan.is_recommended,
          isDisabled: plan.is_disabled || false,
          onSelect: () => onSelectPlan(plan)
        };

        return (
          <PricingPlanCard
            key={plan.id}
            {...planProps}
          />
        );
      })}
    </div>
  );
};

export default PlansList;
